import { pagesMap } from '../../../constants';
import {
  HomeIcon,
  LibraryIcon,
  CustomPageIcon,
  PerformanceIcon,
  TrashIcon,
  SupportIcon,
  AdminStudioIcon,
} from './NgSideNavIcon';

export interface NavLeaf {
  type: 'leaf';
  key: string;
  label: string;
  Icon: React.ComponentType;
  slug: string;
}

export interface FlyoutSection {
  header: string;
  slugs: string[];
}

export interface NavGroup {
  type: 'group';
  key: string;
  label: string;
  Icon: React.ComponentType;
  flyoutTitle: string;
  flyoutTitleSlug?: string;
  childSlugs?: string[];
  sections?: FlyoutSection[];
}

export type NavEntry = NavLeaf | NavGroup;

// config
// add, remove, or reorder entries here to change the sidebar.
// 'leaf'  — a single navigable item (shows compact tooltip when collapsed)
// 'group' — has a flyout submenu (hover when collapsed, click when expanded)

export const NAV_CONFIG: NavEntry[] = [
  {
    type: 'leaf',
    key: 'home',
    label: 'Home',
    Icon: HomeIcon,
    slug: 'home',
  },
  {
    type: 'group',
    key: 'library',
    label: 'Library',
    Icon: LibraryIcon,
    flyoutTitle: 'Library',
    flyoutTitleSlug: 'company-assets',
    childSlugs: ['company-assets', 'my-assets', 'shared'],
  },
  {
    type: 'leaf',
    key: 'custom-page',
    label: 'Custom Page',
    Icon: CustomPageIcon,
    slug: 'custom-page',
  },
  {
    type: 'group',
    key: 'performance',
    label: 'Performance',
    Icon: PerformanceIcon,
    flyoutTitle: 'Performance',
    flyoutTitleSlug: 'reports',
    childSlugs: ['reports'],
  },
  {
    type: 'leaf',
    key: 'trash',
    label: 'Trash',
    Icon: TrashIcon,
    slug: 'trash',
  },
  // {
  //   type: 'leaf',
  //   key: 'support',
  //   label: 'Help & Support',
  //   Icon: SupportIcon,
  //   slug: 'support',
  // },
  {
    type: 'group',
    key: 'admin',
    label: 'Admin Studio',
    Icon: AdminStudioIcon,
    flyoutTitle: 'Admin Studio',
    sections: [
      {
        header: 'Users',
        slugs: ['users', 'groups'],
      },
      {
        header: 'Infrastructure',
        slugs: [pagesMap.workspaceTemplates.slug, 'slidespaces', 'entities', 'settings'],
      },
      {
        header: 'Slides',
        slugs: ['themes', pagesMap.categories.slug, 'starter-decks'],
      },
    ],
  },
];
